import { parse as yamlParse } from 'yaml';
export class RemedyParseError extends Error {
    path;
    constructor(message, path) {
        super(message);
        this.path = path;
        this.name = 'RemedyParseError';
    }
}
export function parseRemedyString(source, path) {
    let doc;
    try {
        doc = yamlParse(source);
    }
    catch (e) {
        const msg = e instanceof Error ? e.message : String(e);
        throw new RemedyParseError(`YAML parse error: ${msg}`, path);
    }
    if (doc === null || typeof doc !== 'object' || Array.isArray(doc)) {
        throw new RemedyParseError('Root of .remedy must be a YAML mapping.', path);
    }
    return doc;
}
//# sourceMappingURL=parse.js.map